const GEO_API_URL = 'https://geo.ulule.com/json/'
const DEFAULT_LOCATION = {
  country: 'FR'
}

const parseData = json => {
  return json
}

export const notify = json => {
  const locationLoadedEvent = new CustomEvent('js:location:loaded', { detail: json })
  window.dispatchEvent(locationLoadedEvent)

  return json
}

const fetchLocation = () => {
  return fetch(GEO_API_URL)
    .then(res => res.json())
    .then(json => parseData(json))
}

export const setCurrentLocation = data => {
  return (window.CURRENT_LOCATION = data)
}

export const getCurrentLocation = async () => {
  let locationData = window.CURRENT_LOCATION

  if (locationData) {
    return locationData
  }

  try {
    locationData = await fetchLocation()
  } catch (error) {
    console.error('Oops, there is an error', error)
    throw error
  }

  return locationData
}
